import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";

interface Props {
	tagList: string[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const DepartureDayComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const dataList = dataStr.replaceAll("|", "").split("^");

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id="wdayList0"
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value="전체"
				/>
				<label htmlFor="wdayList0">
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{dataList.map((value, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`wdayList${idx + 1}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.includes(value)}
						value={value}
					/>
					<label htmlFor={`wdayList${idx + 1}`}>
						<span>{value}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const DepartureDay = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter DepartureDay Error">
		<DepartureDayComponent {...props} />
	</ErrorBoundary>
);

export default DepartureDay;
